import { useEffect, useRef, useState } from 'react';
import { Maybe } from 'api';

type Pagination<T, K> = {
    data: K | undefined;
    nodes: T[] | undefined;
    page: Maybe<number> | undefined;
    fetching: boolean;
    id: string;
};

export const usePagination = <T, K>({ data, page, fetching, nodes, id }: Pagination<T, K>) => {
    const pageRef = useRef(page);
    const idRef = useRef(id);

    const [paginationData, setPaginationData] = useState<T[]>([]);

    useEffect(() => {
        const isReady = nodes && !fetching;

        if (idRef.current !== id) {
            setPaginationData([]);
            idRef.current = id;
        }

        if (page !== pageRef.current && isReady) {
            setPaginationData([...paginationData, ...nodes]);
            pageRef.current = page;
        } else if (page === 1 && isReady && paginationData.length > 0) {
            setPaginationData(nodes || []);
        }

        if (paginationData.length === 0 && isReady) {
            setPaginationData(nodes || []);
        }
    }, [page, data, fetching]);

    return {
        paginationData,
    };
};
